import React from 'react';
import { connect } from 'react-redux';
import { Button, Icon } from '@syneto/compass-react';
import UserRoles from '../../../constants/user-roles';

const NAV_ROLES = [
	UserRoles.CLIENT,
	UserRoles.OPERATIONS,
	UserRoles.SUPPORT_ENGINEER,
	UserRoles.MARKETING,
	UserRoles.ADMINISTRATOR
];

const NavBreadcrumbConst = (props) => {
	const { menuSections, userRole } = props;
	const { headerSectionLabel, headerTextIdentifier } = menuSections;

	if (!NAV_ROLES.includes(userRole)) {
		return null;
	}

	return (
		<ol className="app-breadcrumb">
			{
				headerSectionLabel && (
					<li className="app-breadcrumb-section">
						{ headerSectionLabel }
						<Icon name="far fa-chevron-right" className="app-breadcrumb-separator" />
					</li>
				)
			}
			<li className="app-breadcrumb-current" aria-current="page">{ headerTextIdentifier }</li>
		</ol>
	);
};

const NavActionsConst = (props) => {
	const { menuSections, userRole } = props;
	const { headerMenuOptions } = menuSections;

	if (!NAV_ROLES.includes(userRole) || !headerMenuOptions?.length) {
		return null;
	}

	return (
		<div className="app-header-actions">
			{
				headerMenuOptions.map((headerMenuOption, key) => {
					return (
						<Button
							key={ key }
							role="tertiary"
							onClick={ () => { return headerMenuOption.fnToExecute(); } }
							type="submit"
						>
							{ headerMenuOption.menuTitle }
						</Button>
					);
				})
			}
		</div>
	);
};

const mapStateToProps = ({ menuSections }) => { return { menuSections: menuSections.section }; };

export const NavBreadcrumb = connect(mapStateToProps)(NavBreadcrumbConst);
export const NavActions = connect(mapStateToProps)(NavActionsConst);
